import React, { useState, useEffect } from "react";
import { AromMenuOptions } from "../../movenet/params";

const AromCountdownTimer = () => {
  const assessment = sessionStorage.getItem("selectedAssesment");
  // Assessment 1 = mCTSIB (30 sec), Assessment 55 = upper body AROM (15 sec), others = 10 sec
  const initialDuration = assessment === "1" ? 30 : assessment === "55" ? 15 : 10;

  const [duration] = useState(initialDuration);
  const [timeLeft, setTimeLeft] = useState(initialDuration);

  // const [timeLeft, setTimeLeft] = useState(duration);

  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      let start_time = AromMenuOptions.actualAssessmentStartTime;
      let current_time = Date.now();
      let time_diff = Math.floor((current_time - start_time) / 1000);

      setTimeLeft((prev) => duration - time_diff);
    }, 100);

    return () => clearInterval(timer);
  }, [timeLeft, duration]);

  const progress = Math.ceil((timeLeft / duration) * 100);

  return (
    <>
      <div
        // id="arom-counter-shape"
        style={{
          textAlign: "center",
          position: "fixed",
          zIndex: 100,
          right: "140px",
          bottom: "40px",
          fontSize: "60px",
          fontFamily: "bold",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "554px",
            height: "81px",
            padding: "16px 32px 16px 32px",
            gap: "10px",
            borderRadius: "12px",
            background: "#000000B2",
            alignItems: "center",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "400px",
              height: "20px",
              borderRadius: "8px",
              background: "#D9D9D9",
              overflow: "hidden",
            }}
          >
            {/* Progress Fill */}
            <div
              style={{
                width: `${100 - progress}%`,
                height: "100%",
                background: "#7A2F9D",
                borderRadius: "8px",
                transition: "width 1s linear",
              }}
            ></div>
          </div>
          <div
            style={{
              color: "white",
              fontSize: "36px",
              fontWeight: 700,
              lineHeight: "49.03px",
              textAlign: "center",
            }}
          >
            {`0:${String(timeLeft).padStart(2, "0")}`}
          </div>
        </div>
      </div>
    </>
  );
};

export default AromCountdownTimer;
